module.exports = __webpack_public_path__ + "static/img/banner2.4d89479.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner2.jpg
// module id = 7/Ek
// module chunks = 21